// src/App.js
import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import About from "./pages/About";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Elevate from './pages/Elevate';
import NewElite from "./pages/NewElite";
// import Business4 from "./pages/Business4";
import Vodafone from "./pages/Vodafone";
import Northstar from './pages/Northstar';
import './App.css';
import Footer from "./components/Footer";
import CareerDetails from "./pages/CareerDetails";
import ItSolution from "./pages/ItSolution";
import TowersTraining from "./pages/TowersTraining";
import Hrsolution from "./pages/Hrsolution";
import Cxda from "./pages/Cxda";

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/northstar" element={<Northstar />} />
        <Route path="/elevate" element={<Elevate />} />
        <Route path="/newelite" element={<NewElite />} />
        {/* <Route path="/business4" element={<Business4 />} /> */}
        <Route path="/vodafone" element={<Vodafone />} />
        <Route path="/job/:id" element={<CareerDetails />} />
        <Route path="/itsolution" element={<ItSolution />} />
        <Route path="/towertraining" element={<TowersTraining/>} />
        <Route path="/hrsolution" element={<Hrsolution/>} />
        <Route path="/cxda" element={<Cxda/>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
